/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_area_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why isn't an acre a round number of square meters?`)
};

const es_uc_area_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué un acre no es un número redondo de metros cuadrados?`)
};

const de_uc_area_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum ist ein Acre keine runde Anzahl Quadratmeter?`)
};

const nl_uc_area_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom is een acre geen rond getal van vierkante meter?`)
};

const fr_uc_area_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi un acre n'est-il pas un nombre rond de mètres carrés ?`)
};

const it_uc_area_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché un acro non è un numero rotondo di metri quadrati?`)
};

const pt_br2_uc_area_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que um acre não é um número redondo de metros quadrados?`)
};

const pt_uc_area_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que um acre não é um número redondo de metros quadrados?`)
};

const ja_uc_area_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エーカーがなぜ平方メートルの丸い数ではないのですか?`)
};

const zh_uc_area_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation B]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_area_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_area_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_area_faq3_q", locale)
	if (locale === "en") return en_uc_area_faq3_q(inputs)
	if (locale === "es") return es_uc_area_faq3_q(inputs)
	if (locale === "de") return de_uc_area_faq3_q(inputs)
	if (locale === "nl") return nl_uc_area_faq3_q(inputs)
	if (locale === "fr") return fr_uc_area_faq3_q(inputs)
	if (locale === "it") return it_uc_area_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_area_faq3_q(inputs)
	if (locale === "pt") return pt_uc_area_faq3_q(inputs)
	if (locale === "ja") return ja_uc_area_faq3_q(inputs)
	return zh_uc_area_faq3_q(inputs)
};